import { useContext } from "react";
import { ContextoDaSessao, type Sessao } from "./contexto";

export function useSessao(): Sessao {
  const sessao = useContext(ContextoDaSessao);
  if (sessao === null) {
    throw new Error("useSessao precisa de um <ProvedorDaSessao> acima na árvore.");
  }
  return sessao;
}
